import { Injectable } from '@angular/core';
import { LanguageService } from '../language/language.service';
import { Dictionary } from 'projects/common/src/app/classes/dictionary';
import { NotificationHandlerService } from 'projects/common/src/app/services';
import { IError } from 'projects/common/src/app/interfaces';
import { ParameterAsync } from '../../../classes';
import { CommunicationService } from 'src/app/services/communication';

/**
 * Servicio que provee metodos para la añadir y obtener un diccionario de una colección
 * de diccionarios
 */
@Injectable({
  providedIn: 'root'
})
export class LanguageCollectionService extends ParameterAsync<Dictionary<string>> {

  private collection: Dictionary<Dictionary<string>>;

  constructor(
    protected httpService: CommunicationService,
    protected notificationService: NotificationHandlerService,
    private languageService: LanguageService
  ) {
    super(httpService, notificationService);
    this.name = 'language-collection';
    this.urlEndpoint = 'lang';
    this.collection = new Dictionary();
    this.languageService.getObservable().subscribe((language: string) => this.start());
  }

  /**
   * Obtiene la configuración de idioma dada por argumento
   */
  public start(): Promise<Dictionary<string>> {
    return new Promise((resolve, reject) => {
      const targetLanguage = this.languageService.get();
      if (targetLanguage) {
        this.log(`Iniciando carga de idioma [${targetLanguage}]`);
        if (this.collection.containsKey(targetLanguage)) {
          this.log(`Archivo de idioma cargado [${targetLanguage}]`);
          this.set(this.collection.item(targetLanguage));
        } else {
          this.warn(`Archivo de idioma [${targetLanguage}] no encontrado. Solicitando...`);
          // TODO buscar en servidor lenguajes disponibles
          import(`src/assets/${this.urlEndpoint}/${targetLanguage}.json`).then(
            (result: any) => {
              if (result && result.default) {
                this.log(`Archivo de idioma [${targetLanguage}] cargado.`);
                this.addCollection(targetLanguage, result.default);
                this.set(this.collection.item(targetLanguage));
                resolve(result.default);
              } else {
                // TODO informar error en carga de idioma
                // TODO mensaje a config
                this.error(`Error en resultado de solicitud de idioma [${targetLanguage}]`);
                this.set(null);
                resolve(null);
              }
            },
            (error: Error) => {
              // TODO informar error en carga de idioma
                // TODO mensaje a config
              this.error(`Error en solicitud de lenguaje [${targetLanguage}].`, error.message);
              this.notificationService.error(
                `Error en solicitud de lenguaje [${targetLanguage}].`,
                null, null,
                () => this.start(),
              );
              this.set(null);
              resolve(null);
            }
          );
        }
      } else {
        reject({message: 'INVALID_VALUE'} as IError);
      }
    });
  }

  /**
   * Retorna el valor de la colección si éste existe o null
   * @param lang valor del lenguaje seleccionado
   */
  public getCollection(lang: string): Dictionary<string> {
    if (this.target) {
      return this.target;
    } else {
      this.error(`lenguaje [${lang}] no encontrado.`);
      return null;
    }
  }

  /**
   * Añade una nueva colección al diccionario de idiomas
   * @param lang nombre del idioma
   * @param collection diccionario con los valores para definir un parámetro de idioma
   */
  private addCollection(lang: string, collection: {[key: string]: string}): void {
    this.collection.addOrReplace(lang, this.buildDictionary(collection));
  }

  /**
   * Crea una instancia de diccionario con el objeto dado por argumento
   * @param collection diccionario de parámetros
   */
  private buildDictionary(collection: {[key: string]: string}): Dictionary<string> {
    const resultDictionary = new Dictionary<string>();
    for (const key in collection) {
      if (collection.hasOwnProperty(key)) {
        const element = collection[key];
        resultDictionary.add(key, element);
      }
    }
    return resultDictionary;
  }
}
